import Vue from "vue";
import VueRouter from "vue-router";
import MainView from "../views/MainView.vue"
import AdminView from "../views/AdminView.vue"
import MarkupsView from "../views/MarkupsView.vue"
import FlutterView from "../views/FlutterView.vue"
import appConfig from '../../appConfig';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'viewer',
        component: MainView
    },
    {
        path: '/viewer',
        name: 'viewer',
        component: MainView
    },
    {
        path: '/viewLocal.html',
        name: 'viewLocal.html',
        component: MainView
    },
    {
        path: '/admin',
        name: 'AdminView',
        component: AdminView
    },
    {
        path: '/adminLocal.html',
        name: 'adminLocal.html',
        component: AdminView
    },
    {
        path: '/markups',
        name: 'MarkupsView',
        component: MarkupsView
    },    
    {
        path: '/markups.html',
        name: 'MarkupsView.html',
        component: MarkupsView
    },
    {
        path: '/markupsLocal.html',
        name: 'MarkupsViewLocal.html',
        component: MarkupsView
    },
    {
        path: '/flutter',
        name: 'FlutterView',
        component: FlutterView
    },
    {
        path: '/flutterView.html',
        name: 'FlutterView.html',
        component: FlutterView
    }
]

const router = new VueRouter({
    mode: "history",
    base: appConfig.appRoot,
    routes
});
export default router;